import { render, staticRenderFns } from "./AccountManagementFeatureFlagsTab.container.vue?vue&type=template&id=2abdeff1&"
import script from "./AccountManagementFeatureFlagsTab.container.vue?vue&type=script&lang=ts&"
export * from "./AccountManagementFeatureFlagsTab.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports